import React, { ChangeEvent, FC, FormEvent, useEffect, useState } from "react";
import Breadcrumb, { Crumb } from "../../../../components/common/Breadcrumbs";
import { useNavigate, useParams } from "react-router-dom";
import {
    useCreateTenantMutation,
    useGetTenantByIdQuery,
    useUpdateTenantLogoMutation,
    useUpdateTenantMutation
} from "../tenantApi";
import AuditableInfoButton from "../../../../components/common/form/AuditableInfoButton";
import Form from "../../../../components/common/form/Form";
import InputField from "../../../../components/common/form/InputField";
import ButtonTray from "../../../../components/common/form/ButtonTray";
import { Routes as AppRoutes } from "../../../../routes";
import { hasPermission } from "../../../../helpers/utils/AccessControlUtils";
import { handleRTKQuery } from "../../../../helpers/utils/RtkQueryUtils";
import { FaTrash } from "react-icons/fa";
import ConfirmationModal from "../../../../components/layout/modal/ConfirmationModal";
import { tgxApi } from "../../../../app/tgxApi";

interface props {
    crumbs: Crumb[];
    title: string,
    btnText: string,
    isReadOnly?: boolean
}

const TenantForm: FC<props> = ({ crumbs, title, btnText, isReadOnly }) => {

    const navigate = useNavigate();
    let { tenantId } = useParams();

    const tenantByIdApi = useGetTenantByIdQuery(tenantId);
    const [tenantData, setTenantData] = useState<any>({});
    const [createTenantData, createTenantDataApiResponse] = useCreateTenantMutation();
    const [updateTenantApi, updateTenantApiResponse] = useUpdateTenantMutation();
    const [updateLogoApi, updateLogo] = useUpdateTenantLogoMutation();
    const [file, setFile] = useState<File | null>(null);
    const [icon, setIcon] = useState<File | null>(null);
    const [showRemoveLogoConfirmation, setShowRemoveLogoConfirmation] = useState(false);
    const [showRemoveFaviconConfirmation, setShowRemoveFaviconConfirmation] = useState(false);
    const [favicon, setFavicon] = useState<File | string | null>(null);
    const [logo, setLogo] = useState<File | string | null>(null);
    const [disable, setDisable] = useState(false);

    function removeCurrentFavicon() {
        setFavicon(null)
        setShowRemoveFaviconConfirmation(false);
    }
    function handleRemoveCurrentFavicon() {
        setShowRemoveFaviconConfirmation(true);
    }
    function removeCurrentLogo() {
        setLogo(null)
        setShowRemoveLogoConfirmation(false);

    }
    function handleRemoveCurrentLogo() {
        setShowRemoveLogoConfirmation(true);
    }
    useEffect(() => {
        if (tenantByIdApi != null && tenantByIdApi.data != null) {
            setLogo(tenantByIdApi.data.logoImageId);
            setFavicon(tenantByIdApi.data.faviconId);
        }
    }, [tenantByIdApi.data]);

    const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        const updatedData = {
            ...tenantByIdApi.data,
            ...tenantData,
            logoImageId: logo,
            faviconId: favicon,
        };


        const createOrUpdateBillRelease = async () => {
            if (btnText === "Create") {
                return  await createTenantData(updatedData).unwrap();
            } else {
                await updateTenantApi({
                    id: tenantId,
                    requestBody: updatedData,
                }).unwrap();

                if (file || icon) {
                    return await updateLogoApi({
                        id: tenantId,
                        logo: file,
                        icon: icon
                    }).unwrap();
                }

            }
        };

        await handleRTKQuery(createOrUpdateBillRelease, (response: any) => {
            if (response?.success || response?.data?.success) {
                setTenantData({});
                navigate(AppRoutes.Tenants.path);
            }
        });
    };
    useEffect(() => {
        if (tenantByIdApi) {
            setTenantData({
                ...tenantByIdApi.data,
            });
        }
    }, [tenantByIdApi]);
    const handleLogoClick = (imageId: any) => {
        const url = `${process.env.REACT_APP_BASE_URL}/ajax/image/bytes/${imageId}`;
        window.open(url, "_blank"); // Open the URL in a new tab or window
    };
    const handleOnChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement> | { name: string; value: any }) => {
        const { name, value } = "target" in e ? e.target : e;
        setTenantData((prev: any) => ({ ...prev, [name]: value }));
    };

    return (
        <>
            <div className="adduser_container px-4 py-2">
                <div className="justify-between sm:block md:flex lg:flex">
                    <Breadcrumb crumbs={crumbs} />
                </div>
                <div className="flex justify-center mt-3">
                    <div className="bg-text-0 lg:w-4/6 sm:w-full p-5 rounded-md shadow-[0_0_10px_-2px_rgba(0,0,0,0.2)]">
                        <h3 className="text-xl font-semibold text-surface-0 pb-3 border-b border-surface-7">
                            {title}
                        </h3>
                        <Form onSubmit={handleSubmit} fields={
                            <>
                                <InputField
                                    name="name"
                                    label="Name"
                                    onChange={handleOnChange}
                                    value={tenantData?.name || ""}
                                    required
                                    placeholder="Enter Name..."
                                    disabled={isReadOnly}
                                />
                                <InputField
                                    name="baseUrl"
                                    label="Base Url"
                                    onChange={handleOnChange}
                                    value={tenantData?.baseUrl || ""}
                                    placeholder="Enter Url..." disabled={isReadOnly}
                                />

                                <InputField
                                    name="logo"
                                    label="Logo (936×116)"
                                    type="file"
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                        if (e.target.files && e.target.files.length > 0) {
                                            setFile(e.target.files[0]);
                                        }
                                    }}
                                    disabled={isReadOnly}
                                    placeholder="Choose file"
                                />
                                <div className={'col-span-12 grid grid-cols-12 gap-3 mt-3'}>
                                    <div className={'col-span-3'}>
                                        {logo ? (
                                            <div className="flex items-center space-x-2">
                                                <p
                                                    className="text-highlight-4 font-semibold cursor-pointer m-0"
                                                    onClick={() => handleLogoClick(tenantData?.logoImageId)}
                                                >
                                                    (Current Logo)
                                                </p>
                                                <FaTrash className="text-text-7 hover:text-red-500 cursor-pointer"
                                                    onClick={handleRemoveCurrentLogo} />
                                            </div>
                                        ) : (
                                            <p className="text-highlight-4 font-semibold ml-2 cursor-pointer">(No
                                                logo)</p>
                                        )}
                                    </div>
                                    <div className={'col-span-9'}>
                                        <p className="text-text-7 text-sm">936×116 banner style logo with no
                                            whitespace</p>
                                    </div>
                                </div>


                                <InputField
                                    name="faviconId"
                                    label="FavIcon (936×116)"
                                    type="file"
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                        if (e.target.files && e.target.files.length > 0) {
                                            setIcon(e.target.files[0]);
                                        }
                                    }}
                                    disabled={isReadOnly}
                                    placeholder="Enter Url..."
                                />
                                <div className={'col-span-12 grid grid-cols-12 gap-3 mt-3'}>
                                    <div className={'col-span-3'}>
                                        {favicon ? (
                                            <div className="flex items-center space-x-2">
                                                <p
                                                    className="text-highlight-4 font-semibold cursor-pointer m-0"
                                                    onClick={() => handleOnChange(tenantData?.faviconId)}
                                                >
                                                    (Current Logo)
                                                </p>
                                                <FaTrash className="text-gray-500 hover:text-red-500 cursor-pointer
                                                " onClick={handleRemoveCurrentFavicon} />
                                            </div>
                                        ) : (
                                            <p className="text-highlight-4 font-semibold ml-2 cursor-pointer">(No
                                                logo)</p>
                                        )}
                                    </div>
                                    <div className={'col-span-9'}>
                                        <p className="text-gray-500 text-sm">100×100 favicon logo</p>

                                    </div>

                                </div>


                                <InputField
                                    name="primaryTenant"
                                    label="Primary Tenant"
                                    type="checkbox"
                                    checked={tenantData.primaryTenant}
                                    disabled={isReadOnly}
                                    onChange={() =>
                                        setTenantData((prev: { primaryTenant: any }) => ({
                                            ...prev,
                                            primaryTenant: !prev.primaryTenant,
                                        }))
                                    }
                                />

                                {!isReadOnly &&
                                    <div className="col-span-12 md:grid md:grid-cols-12 gap-3">
                                        <div className="col-span-3 sm:mt-2 lg:mt-0 mt-2 flex items-center">
                                        </div>
                                        <div className="relative col-span-9">
                                            <div className={"mt-4 flex"}>
                                                <ButtonTray buttons={[
                                                    {
                                                        buttonProps: {
                                                            btnText: "Cancel",
                                                            onClick: () => navigate(AppRoutes.Tenants.path),
                                                            type: "cancel"
                                                        },
                                                        buttonType: "button"
                                                    },
                                                    {
                                                        buttonProps: {
                                                            btnText: "Submit",
                                                            type: "submit",
                                                            isLoading: (createTenantDataApiResponse.isLoading || updateTenantApiResponse.isLoading),
                                                            isVisible: hasPermission(["CANNOTE-U"])
                                                        },
                                                        buttonType: "button"
                                                    }
                                                ]} align="center" gap={2} />
                                            </div>
                                        </div>
                                    </div>}
                            </>
                        } />
                    </div>
                </div>
            </div>
            {
                showRemoveLogoConfirmation ?
                    <ConfirmationModal title={"Delete Current Logo"}
                        bodyMessage={"Are you sure you want to remove current logo?"}
                        onSubmit={removeCurrentLogo} show={showRemoveLogoConfirmation}
                        setShow={setShowRemoveLogoConfirmation}
                        isLoading={disable}

                    /> : <></>
            }
            {
                showRemoveFaviconConfirmation ?
                    <ConfirmationModal title={"Delete Current fav Icon"}
                        bodyMessage={"Are you sure you want to remove current fav icon?"}
                        onSubmit={removeCurrentFavicon} show={showRemoveFaviconConfirmation}
                        setShow={setShowRemoveFaviconConfirmation}
                        isLoading={disable}

                    /> : <></>
            }
        </>
    )
}
export default TenantForm;

